<template>
    <v-banner v-if="showCookiesBanner" lines="one" class="cookies-banner">
        <v-row class="d-flex justify-center align-center cookiesText">
            <v-col cols="12" sm="9" md="10" lg="8" xl="7"><v-row class="flex-column">
                    <v-col class="pb-0"> Daha iyi bir deneyim için izninizi istiyoruz.</v-col>
                    <v-col cols=" pt-0">İnternet sitemizde deneyimlerinizi kişiselleştirmek amacıyla çerezler
                        kullanılmakta
                        olup, izin vermeniz halinde zorunlu çerezler haricindeki çerezlerle toplanan veriler
                        işlenmektedir.

                        <span class="text-decoration-underline custom-clickable" @click="declineCookies">
                            Reddet
                        </span>
                        seçeneğine tıklamanız halinde tercih ve ilgi alanlarına yönelik maalesef size özel bir deneyim
                        sunamayacağız. Çerezler bakımından kişisel tercihlerinizi, seçeneklerde yer alan çerez ayarları
                        kısmından
                        yönetebilir, çerezlerle ilgili detaylı bilgiye buradan ulaşabilirsiniz:
                        <span class="text-decoration-underline custom-clickable" @click="gotoCookiesDetail"> Çerezlere
                            Yönelik Aydınlatma
                            Metni</span>
                    </v-col>
                </v-row></v-col>
            <v-col cols="12" sm="3" md="2" lg="3" xl="2" class="pt-0">
                <v-row>
                    <v-col cols="6" sm="12" md="12" lg="6">
                        <v-btn variant="outlined" size="large" class="settingBtn mr-2"
                            @click="cookiesSettingsDialog = true">
                            Çerez Ayarları
                        </v-btn>
                    </v-col>
                    <v-col cols="6" sm="auto">
                        <v-btn variant="outlined" size="large" class="acceptBtn" @click="acceptCookies"> Kabul Et
                        </v-btn>
                    </v-col>
                </v-row>
            </v-col>
        </v-row>
        <cookiesSettingsDialog v-if="cookiesSettingsDialog" :cookiesSettingsDialog="cookiesSettingsDialog"
            @closeDialog="closeCookiesSettingsDialog" />
    </v-banner>
</template>

<script lang="ts">
import { defineComponent, ref, nextTick, onBeforeMount,defineAsyncComponent} from 'vue';
const cookiesSettingsDialog = defineAsyncComponent(() => import('../components/dialogs/cookiesSettingsDialog.vue'));

import { useRouter } from 'vue-router';
import { useMyCookieStore } from '../stores/cookie';


export default defineComponent({
  components: {
    cookiesSettingsDialog,
  },
  setup() {
    const showCookiesBanner = ref(false);
    const useStore = useMyCookieStore();
    const cookiesSettingsDialog = ref(false);
    const router = useRouter();
   
    onBeforeMount(() => {
      nextTick(() => {
        const cookiesAccepted = useCookie('cookiesAccepted').value;
        if (cookiesAccepted) {
          showCookiesBanner.value = false;
        } else {
            showCookiesBanner.value = true;
            useStore.updateModelPerformans(true);
            useStore.updateModelHedefleme(true);
            useStore.updateModelIslevsel(true);
        }
      });
    });

    const acceptCookies = () => {
      useStore.acceptCookies();
      showCookiesBanner.value = false;
    };

    const declineCookies = () => {
      useStore.declineCookies();
      showCookiesBanner.value = false;
    };

    const closeCookiesSettingsDialog = (val: string) => {
      if (val === 'closeBanner') showCookiesBanner.value = false;
      else cookiesSettingsDialog.value=false;
    };

    const gotoCookiesDetail = () => {
      router.push({ path: `/${'cerez-yonetimi'}/${'cerezlere-yonelik-aydinlatma-metni'}`, replace: true });
    };

    return {
      acceptCookies,
      declineCookies,
      showCookiesBanner,
      closeCookiesSettingsDialog,
      cookiesSettingsDialog,
      gotoCookiesDetail,
    };
  },
});
</script>

<style lang="less">
.custom-clickable {
    color: var(--color-cookie-blue);
    cursor: pointer;
}

.cookies-banner {
    position: fixed;
    bottom: 0;
    /* Banner'ı en üste sabitle */
    left: 0;
    width: 100%;
    z-index: 9999;
    /* Banner'ı diğer içeriklerin üstüne getir */
    background-color: var(--color-title);
    color: white;
    text-align: left;
    padding: 16px;
    /* İçeriklere uygun padding ekleyin */
    box-shadow: 0px 2px 5px rgba(0, 0, 0, 0.1);
    /* Gölgeler */
    font-size: 16px;
    /* Yazı boyutu */
}
@media only screen and (max-device-width: 320px) {
    .cookies-banner {
        height: 240px !important;
    }
    .cookiesText{
        text-align: justify;
        letter-spacing: 0px !important;
        line-height: 1.2;
        font-size: 12px;
    }
}
@media only screen  and (min-device-width: 321px) and (max-device-width: 375px) {
    .cookies-banner {
        height: 220px !important;
    }
    .cookiesText{
        text-align: justify;
        letter-spacing: 0px !important;
        line-height: 1.2;
        font-size: 12px;
    }
}
@media only screen and (min-device-width: 376px) and (max-device-width: 425px) {
    .cookies-banner {
        height: 200px !important;
    }
    .cookiesText{
        text-align: justify;
        letter-spacing: 0px !important;
        line-height: 1.2;
    }
}
@media only screen and (max-device-width: 959px) {
    .acceptBtn {
        background: var(--unnamed-color-247de3) 0% 0% no-repeat padding-box;
        background: #247DE3 0% 0% no-repeat padding-box;
        border: 1px solid var(--color-cookie-blue);
        border-radius: 6px;
        opacity: 1;
        color: white !important;
        
    }

    .settingBtn {
        color: var(--unnamed-color-ffffff);
        text-align: left;
        
        letter-spacing: 0px;
        color: #FFFFFF !important;
        opacity: 1;
    }

    .cookies-banner {
        box-shadow: 0px -2px 5px rgba(0, 0, 0, 0.1);
        letter-spacing: 0px;
        opacity: 1;
        height: 180px;
        font-size: 14px;
    }
}

@media only screen and (max-device-width: 600px) {
    .cookies-banner {
        box-shadow: 0px -2px 5px rgba(0, 0, 0, 0.1);
        letter-spacing: 0px;
        opacity: 1;
        height: 230px;
        font-size: 14px;

    }
}
@media only screen and (max-device-width: 530px) {
    .cookies-banner {
        box-shadow: 0px -2px 5px rgba(0, 0, 0, 0.1);
        text-align: left;
        letter-spacing: 0px;
        opacity: 1;
        height: 270px;
        font-size: 12px;
    }
}
@media only screen and (min-device-width: 961px) {
    .acceptBtn {
        background: var(--unnamed-color-247de3) 0% 0% no-repeat padding-box;
        background: #247DE3 0% 0% no-repeat padding-box;
        border: 1px solid var(--color-cookie-blue);
        border-radius: 6px;
        opacity: 1;
        color: white !important;
    }

    .settingBtn {
        color: var(--unnamed-color-ffffff);
        text-align: left;
       
        letter-spacing: 0px;
        color: var(--color-white) !important;
        opacity: 1;
    }

    .cookies-banner {
        box-shadow: 0px -2px 5px rgba(0, 0, 0, 0.1);
        height: 146px;
        letter-spacing: 0px;
        opacity: 1;
        color: white;

        /* Opsiyonel: Kenarlık rengi */
        background: var(--unnamed-color-001e43) 0% 0% no-repeat padding-box;
        background: var(--color-title) 0% 0% no-repeat padding-box;
        opacity: 0.85;
        padding: 0;
        margin: 0;

    }
}
</style>